import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom'
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import PageTitle from '../../components/pagetitle/PageTitle'

import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo-2.svg'
import ContactForm from './ContactForm';


const EventSinglePage = (props) => {

    const { slug } = useParams()
    const [eventDetails, setEventDetails] = useState(null);
    const [recentBlogs, setRecentBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [eventsRes, blogsRes] = await Promise.all([
                    fetch('/api/events'),
                    fetch('/api/blogs')
                ]);
                const eventsData = await eventsRes.json();
                const blogsData = await blogsRes.json();

                const foundEvent = Array.isArray(eventsData) ? eventsData.find(e => e.slug === slug) : null;
                setEventDetails(foundEvent);
                setRecentBlogs(Array.isArray(blogsData) ? blogsData.slice(0, 3) : []);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [slug]);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const [activeTab, setActiveTab] = useState(0);
    const handleTabClick = (index) => {
        setActiveTab(index);
    }


    const [searchTerm, setSearchTerm] = useState(''); 

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value); 
    };

    const handleSubmit = (e) => {
        e.preventDefault(); 
        setSearchTerm('');
    };


    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
    };

    if (loading) {
        return (
            <Fragment>
                <NavbarS2 hclass={'wpo-site-header'} Logo={Logo} />
                <PageTitle pageTitle="Loading..." pagesub={'Events'} />
                <div className="event-details-area section-padding">
                    <div className="container">
                        <div style={{ textAlign: 'center', padding: '60px' }}>Loading event details...</div>
                    </div>
                </div>
                <Footer />
                <Scrollbar />
            </Fragment>
        );
    }

    if (!eventDetails) {
        return (
            <Fragment>
                <NavbarS2 hclass={'wpo-site-header'} Logo={Logo} />
                <PageTitle pageTitle="Event Not Found" pagesub={'Events'} />
                <div className="event-details-area section-padding">
                    <div className="container">
                        <div style={{ textAlign: 'center', padding: '60px' }}>Event not found.</div>
                    </div>
                </div>
                <Footer />
                <Scrollbar />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <NavbarS2 hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={eventDetails.title} pagesub={'Events'} />
            <div className="event-details-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8">
                            <div className="event-item">
                                <div className="event-img">
                                    <img src={eventDetails.thumb_url || eventDetails.image_url || '/images/events-single/1.jpg'} alt={eventDetails.title} />
                                </div>
                                <div className="event-details-text">
                                    <h2>{eventDetails.title}</h2>
                                    <p>{eventDetails.description}</p>
                                </div>
                                <div className="event-details-wrap">
                                    <div className="event-details-tab">
                                        <ul className="nav nav-tabs">
                                            <li className="nav-item">
                                                <button type="button" className={activeTab === 0 ? 'nav-link active' : "nav-link"} onClick={() => handleTabClick(0)} >Event Schedule</button>
                                            </li>
                                            <li className="nav-item">
                                                <button type="button" className={activeTab === 1 ? 'nav-link active' : "nav-link"} onClick={() => handleTabClick(1)} >Map Location</button>
                                            </li>
                                            <li className="nav-item">
                                                <button type="button" className={activeTab === 2 ? 'nav-link active' : "nav-link"} onClick={() => handleTabClick(2)} >Contact Us</button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="event-details-content">
                                        <div className="tab-content">
                                            <div className={activeTab === 0 ? 'active' : 'hidden'}>
                                                <div id="Schedule" className="tab-pane active">
                                                    <p><strong>Date:</strong> {eventDetails.event_date}<br/>
                                                    {eventDetails.event_time && <><strong>Time:</strong> {eventDetails.event_time}<br/></>}
                                                    <strong>Location:</strong> {eventDetails.location}</p>
                                                </div>
                                            </div>
                                            <div className={activeTab === 1 ? 'active' : 'hidden'}>
                                                <div id="Map" className="tab-pane">
                                                    <div className="contact-map">
                                                        <iframe
                                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d25262.073891373565!2d144.7471839!3d-37.9071573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad68979e7a06f0f%3A0x5045675218cd220!2sPoint%20Cook%20VIC%203030!5e0!3m2!1sen!2sau!4v1700000000000"
                                                            allowFullScreen
                                                            title="Google Map - Point Cook"
                                                            width="600"
                                                            height="450"
                                                            frameBorder="0"
                                                            style={{ border: 0 }}
                                                        ></iframe>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={activeTab === 2 ? 'active' : 'hidden'}>
                                                <div id="Contact" className="tab-pane">
                                                    <div className="event-contact">
                                                        <div className="donations-details">
                                                            <ContactForm />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-4 col-12">
                            <div className="blog-sidebar">
                                <div className="widget search-widget">
                                    <h3>search here</h3>
                                    <form onSubmit={handleSubmit}>
                                        <div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search Post.."
                                                value={searchTerm}
                                                onChange={handleInputChange}
                                            />
                                            <button type="submit">
                                                <i className="ti-search"></i>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div className="widget recent-post-widget">
                                    <h3>Related Posts</h3>
                                    <div className="posts">
                                        {recentBlogs.map((blog, bitem) => (
                                            <div className='post' key={blog.id || bitem}>
                                                <div className="img-holder">
                                                    <img src={blog.thumb_url || blog.image_url || '/images/recent-posts/img-1.jpg'} alt={blog.title} />
                                                </div>
                                                <div className="details">
                                                    <span className="date"><i className="flaticon-calendar"></i>{formatDate(blog.published_at || blog.created_at)}</span>
                                                    <h4><Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>
                                                        {blog.title}</Link>
                                                    </h4>
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                                <div className="widget tag-widget">
                                    <h3>Populer Tags</h3>
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="/blog">Community</Link></li>
                                        <li><Link onClick={ClickHandler} to="/blog">Ramadan</Link></li>
                                        <li><Link onClick={ClickHandler} to="/blog">Education</Link></li>
                                        <li><Link onClick={ClickHandler} to="/blog">Prayer</Link></li>
                                        <li><Link onClick={ClickHandler} to="/blog">Events</Link></li>
                                        <li><Link onClick={ClickHandler} to="/blog">Mosque</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <Scrollbar />

        </Fragment>
    )
};
export default EventSinglePage;
